import multiagent from './multiagent'
import dailideposit from './dailideposit'
import login from './login'
import service from './service' //服务中心
import tradeinfo from './tradeinfo' //交易信息
import accountinfo from './accountinfo' //账户资料
import funds from './funds' //账户资料
import bindAccount from './bindAccount'
import home from './home' //首页
import upgrade from './upgrade'
import activity from './activity'
import Invitefriends from './Invitefriends'
import test from './test'
import account from './account'

export {
  multiagent,
  dailideposit,//总代入金
  login,
  service, //服务中心
  tradeinfo, //交易信息
  accountinfo, //账户资料
  funds, //资金管理
  bindAccount,
  home,
  upgrade,
  activity,
  Invitefriends,
  test,
  account,
}



// WEBPACK FOOTER //
// ./src/api/index.js